<template>
  <v-dialog v-model="dialog" max-width="350px">
    <v-card>
      <v-card-title primary-title class="title">Zaloguj się na konto firmowe</v-card-title>
      <v-card-text>
        <div id="auth-container"></div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import firebase from 'firebase/app';
import firebaseui from 'firebaseui';

export default {
  name: 'Auth',

  data() {
    return {
      dialog: false
    }
  },

  created() {
    if(!window.authui) {
      window.authui = new firebaseui.auth.AuthUI(firebase.auth());
    }
    firebase.auth().onAuthStateChanged(user => {
      if(user) {
        user.getIdToken().then(token => this.$emit('token', token))
      } else {
        this.$emit('token', null);
      }
    })
  },

  methods: {
    signIn() {
      this.dialog = true
      authui.reset();
      let authConfig = {
        signInFlow: 'popup',
        callbacks: {
          signInSuccessWithAuthResult: user => {
            authui.reset();
            this.dialog = false
            setTimeout(resolve, 100);
            return false
          }
        },
        credentialHelper: firebaseui.auth.CredentialHelper.NONE,
        signInSuccessUrl: '/',
        signInOptions: [
          firebase.auth.GoogleAuthProvider.PROVIDER_ID
        ],
        tosUrl: '/none'
      }
      authui.start('#auth-container', authConfig);
    },

    signOut() {
      firebase.auth().signOut();
    }
  }
}
</script>


<style src="firebaseui/dist/firebaseui.css"></style>